import { QueryResources } from '@/lib/datx-jsonapi-react';
import { ProfileTimezones } from '@/resources/ProfileTimezones';
import { ThinProfile } from '@/resources/ThinProfile';

export const queryProfileTimezones = (
  eventId: string | number,
  thinProfileId: string | number
): QueryResources<ProfileTimezones> => {
  if (!eventId || !thinProfileId) return null;
  return [
    `${ThinProfile.type}/${thinProfileId}/timezones`,
    {
      filter: {
        event_id: eventId,
      },
      params: [
        {
          key: 'page[size]',
          value: '100',
        },
        {
          key: 'page[number]',
          value: '1',
        },
      ],
    },
  ];
};
